<script lang="ts" setup>
import Stepper from "@/views/airline_order/Stepper.vue";
import SubmitView from "@/views/airline_order/grouping/SubmitView.vue";
definePage({
  meta: {
    action: "read",
    subject: "AirlineOrder",
  },
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <Stepper value="submit" />
    </VCol>
    <VCol cols="12">
      <SubmitView />
    </VCol>
  </VRow>
</template>
